import styled, { css } from "styled-components";
import { EmptyState } from "../../components/molecules/EmptyState";

/** Shared visual contract for the secondary and main Data Studio surfaces. */
const panelSurfaceStyles = css`
  min-width: 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  overflow: hidden;
  background: ${({ theme }) => theme.colors.background.primary};
  border: ${({ theme }) => theme.borders.width[1]}
    ${({ theme }) => theme.borders.style.solid}
    ${({ theme }) => theme.colors.border.stroke};
  border-radius: ${({ theme }) => theme.borders.radius.xl};
`;

/** Main workspace wrapper; selected profiles own their individual card surfaces. */
export const PageSurface = styled.section<{
  $hasProfile: boolean;
  $hasRecommendations?: boolean;
}>`
  ${panelSurfaceStyles}
  flex: 1 1 auto;

  ${({ $hasProfile, $hasRecommendations, theme }) =>
    $hasProfile &&
    css`
      display: grid;
      grid-template-columns: minmax(0, 1fr)
        ${$hasRecommendations ? "clamp(17.5rem, 22vw, 21.25rem)" : ""};
      gap: ${$hasRecommendations ? theme.spacing.base[3] : "0"};
      background: transparent;
      border: 0;
      border-radius: 0;

      ${theme.breakpoints.mediaQueries.down.lg} {
        position: relative;
        grid-template-columns: minmax(0, 1fr);

        > aside {
          position: absolute;
          z-index: ${theme.zIndex.docked};
          inset: 0 0 0 auto;
          width: min(21.25rem, 100%);
          box-shadow: ${theme.shadows.elevation[4]};
        }
      }
    `}
`;

/** Fills the workspace while centring non-preview feedback. */
export const PageStateRegion = styled.div`
  display: flex;
  flex: 1 1 auto;
  min-width: 0;
  min-height: 0;
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const PageEmptyState = styled(EmptyState)`
  flex: 1 1 auto;
  min-height: 0;
`;

/** Empty secondary surface that future ingested-table sections compose into. */
export const SecondarySurface = styled.aside`
  ${panelSurfaceStyles}
  width: 100%;
  height: 100%;
`;
